import * as React from 'react';
import { SectionStyle } from '../../../helpers/SectionStyle';
import { WpdfText } from '../../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../../datenauswertung/pdf/WpdfView';

let IS_PDF: boolean;
let STYLE: any;

export function renderTable(data: any, customStyles?: any, isPdf?: boolean, wrap?: boolean): JSX.Element {
    data = data || {};
    IS_PDF = isPdf || false;
    STYLE = new SectionStyle();
    const rows: any[] = data.rows || [];
    const rowStyles: any[] = data.rowStyles || [];
    const styles: any = getStyles(customStyles);

    return (
        <WpdfView style={styles.table} nowrap={!wrap} pdf={isPdf}>
            {rows.map((row: any, rowIndex: number) =>
                <WpdfView key={`row-${rowIndex}`} style={styles.wrapper} pdf={isPdf}>
                    <WpdfView style={styles.row} nowrap pdf={isPdf}>
                        {(rows[rowIndex] || []).map((col: any, colIndex: number) => {
                            const style: any = {
                                ...getStyle((rowStyles[rowIndex] || [])[colIndex]), ...rowIndex && { marginTop: -1 },
                                ...colIndex && { marginLeft: -1 }
                            };
                            return (
                                <WpdfView
                                    key={`col-${colIndex}`}
                                    style={{
                                        ...styles.col,
                                        ...(style.flexBasis && { flexBasis: style.flexBasis }),
                                        ...(style.width && { width: style.width - 1 }),
                                        ...(style.minWidth && { minWidth: style.minWidth - 1 }),
                                        ...(style.maxWidth && { maxWidth: style.maxWidth - 1 }),
                                    }}
                                    pdf={isPdf}
                                >
                                    <WpdfView
                                        refElement={(ref: any) => setNodeTitle(ref, col)}
                                        style={{ ...styles.cell, ...style }}
                                        pdf={isPdf}
                                    >
                                        <WpdfText
                                            style={{
                                                margin: 'auto', ...((!style.textAlign || isPdf) && { marginLeft: 0 }),
                                                overflow: 'hidden', textOverflow: 'ellipsis',
                                                // margin: `auto auto auto ${(!style.textAlign || isPdf) ? 0 : 'auto'}`,
                                                ...(style.textAlign === 'right' && !isPdf && { marginRight: 0 }),
                                                ...(style.verticalAlign === 'top' && { marginTop: 0 }),
                                                ...(style.verticalAlign === 'bottom' && { marginBottom: 0 })
                                            }}
                                            pdf={isPdf}
                                        >
                                            {col || ''}
                                        </WpdfText>
                                    </WpdfView>
                                </WpdfView>
                            );
                        })}
                    </WpdfView>
                </WpdfView>
            )}
        </WpdfView>
    );
}

function getPropStyle(prop: string): any {
    const styles: any = getStyles();

    if (styles[prop]) {
        return styles[prop];
    } else {
        const elements: string[] = (prop || '').toString().split(':');

        switch (elements[0]) {
            case 'width':
                if (!isNaN(+elements[1])) {
                    const width: number = +elements[1] + 1;
                    return { width, minWidth: width, maxWidth: width };
                }
            default:
                return {};
        }
    }
}

function getStyle(data: any): any {
    const css: any = !Array.isArray(data) && typeof data === 'object' && data !== null
        ? data
        : (Array.isArray(data) && (Array.isArray(data[0]) || typeof data[0] === 'string') && !Array.isArray(data[1])
            && typeof data[1] === 'object' && data[1] !== null
            ? data[1] : {}
        );
    const props: string[] = typeof data === 'string'
        ? [data]
        : (Array.isArray(data) && data.every((item) => typeof item === 'string')
            ? data
            : (Array.isArray(data) && Array.isArray(data[0]) && data[0].every((item) => typeof item === 'string')
                ? data[0]
                : (Array.isArray(data) && typeof data[0] === 'string' ? [data[0]] : [])
            )
        );
    let style: any = {};

    props.forEach((prop: string) => {
        style = { ...style, ...getPropStyle(prop) };
    });
    style = { ...style, ...css };

    return style;
}

function getStyles(customStyles?: any): any {
    customStyles = customStyles || {};

    return {
        table: {
            fontSize: '9pt',
            boxShadow: `0 0 10px ${STYLE.getPropertyValue('--color-wform-shadow') || '#e0e0e0'}`,
            ...(customStyles.table || {}),
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
        },
        row: {
            color: 'black',
            backgroundColor: 'white',
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            boxSizing: 'border-box',
        },
        col: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
        },
        cell: {
            textAlign: 'left',
            padding: IS_PDF ? 2 : 4,
            border: '1pt solid white',
            whiteSpace: 'pre-wrap',
            display: 'flex',
            flex: 1,
            boxSizing: 'border-box',
        },
        center: {
            textAlign: 'center',
            justifyContent: 'center',
        },
        right: {
            textAlign: 'right',
            justifyContent: 'flex-end',
        },
        top: {
            verticalAlign: 'top',
        },
        bottom: {
            verticalAlign: 'bottom',
        },
        bold: {
            ...(IS_PDF && { fontFamily: 'Helvetica-Bold' }),
            fontWeight: 600,
        },
        italic: {
            ...(IS_PDF && { fontFamily: 'Helvetica-Oblique' }),
            fontStyle: 'italic',
        },
        underline: {
            textDecoration: 'underline',
        },
        larger: {
            fontSize: '10pt',
        },
        narrow: {
            fontSize: '8pt',
            paddingTop: IS_PDF ? 1 : 2,
            paddingBottom: IS_PDF ? 1 : 2,
        },
        title: {
            fontSize: '10pt',
            ...(IS_PDF && { fontFamily: 'Helvetica-Bold' }),
            fontWeight: 'bold',
            color: 'black',
            backgroundColor: '#e9e9e9',
        },
        head: {
            color: STYLE.getPropertyValue('--color-button-text') || 'white',
            backgroundColor: STYLE.getPropertyValue('--color-section-main') || '#ea9956',
        },
        light: {
            backgroundColor: '#f7f7f7',
        },
        lighter: {
            backgroundColor: '#f9f9f9',
        },
        dark: {
            backgroundColor: '#dadada',
        },
        overlay: {
            overflow: 'visible',
        },
        'noborder-top': {
            borderTop: 'none',
        },
        'noborder-bottom': {
            borderBottom: 'none',
        },
        'noborder-left': {
            borderLeft: 'none',
        },
    };
}

function setNodeTitle(ref: any, title: any): void {
    if (!ref || typeof title !== 'string') {
        return;
    }
    const node: HTMLElement = (ref.children || []).length ? ref.children[0] : {};

    if (node.offsetWidth < node.scrollWidth && node.title !== title) {
        node.title = title;
    } else if (node.offsetWidth === node.scrollWidth && node.title) {
        node.removeAttribute('title');
    }
}
